<template>
  <div class="step">
    <div
      ref="mountRef"
      class="drawing"
      v-loading="loading"
    >
      <Slider
        v-if="!loading"
        class="tool-bar-slider"
        max="200"
        :value="drawZoom"
        @input="handleZoomChange"
      />
      <div ref="msgRef"></div>
    </div>
    <NoAuditRoles
      v-if="startSetLayer.visible"
      :appters="startSetLayer.appters"
      :user-group="startSetLayer.userGroup"
      @update:visible="startSetLayer.visible=$event"
      @click:ok="handleSetOk"
    />
    <DrawerAuditRole
      v-if="auditRoleLayer.visible"
      :tmpl-code="tmplCode"
      :default="auditRoleLayer.default"
      @update:visible="auditRoleLayer.visible=$event"
      @click:ok="handleAuditRoleOk"
    />
    <DrawerOptionalRole
      v-if="optionalRoleLayer.visible"
      :default="optionalRoleLayer.default"
      @update:visible="optionalRoleLayer.visible=$event"
      @click:ok="handleOptionalRoleOk"
    />
    <DrawerAssignRole
      v-if="assignRoleLayer.visible"
      :default="assignRoleLayer.default"
      @update:visible="assignRoleLayer.visible=$event"
      @click:ok="handleAssignRoleOk"
    />
  </div>
</template>
<script>
import {isIE} from '../../utils/index';
import { getAuditRoleByCode } from '../service';
import AntTooltip from './ant-tooltip';
import Slider from './slider.vue';
import DrawerAuditRole from './audit-role.vue';
import NoAuditRoles from './no-audit-roles.vue';
import DrawerAssignRole from './assign-role.vue';
import DrawerOptionalRole from './optional-role.vue';
import { registerAuditCard } from '../../utils/g6-tools';
import { uuid } from '../../utils';
export default {
  components: {
    NoAuditRoles,
    DrawerAuditRole,
    DrawerAssignRole,
    DrawerOptionalRole,
    Slider
  },
  inject: [ 'disableSponsor' ],
  props: {
    title: String,
    tmplCode: String,
    connects: Array,
    nodeList: Array,
    isEdit: Boolean
  },
  data() {
    return {
      nodes: [],
      edges: [],
      startSetLayer: {
        visible: false
      },
      auditRoleLayer: {
        visible: false
      },
      assignRoleLayer: {
        visible: false
      },
      optionalRoleLayer: {
        visible: false
      },
      drawZoom: 100,
      optionRoles: [],
      loading: false,
      nodeOptions: [],
      roleList: []
    };
  },
  computed: {
    // nodeOptions() {
    //   const list=[
    //     { label: this.$t('pc_menu_type_0'), value: 0 },
    //     { label: this.$t('pc_menu_type_1'), value: 1 },
    //     { label: this.$t('pc_menu_type_2'), value: 2, optType: 'openLayer' },
    //     { label: this.$t('pc_menu_type_3'), value: 3, optType: 'openLayer' }
    //   ];
    //   if (this.disableSponsor === false) {
    //     list.push({ label: this.$t('pc_menu_type_4'), value: 4, optType: 'openLayer' })
    //   }
    //   return list;
    // },
    nodeOptionsMap() {
      return this.nodeOptions.reduce((cur, it) => {
        cur[it.value] = it.label;
        return cur;
      }, {});
    },
    getLang() {
      const currentLang = localStorage.getItem('yxtLang');
      return currentLang === 'zh' || currentLang === 'ha';
    }
  },
  watch: {
    nodes() {
      if (this.graph) {
        this.renderOrReflash();
      }
    },
    nodeList: {
      immediate: true,
      handler() {
        this.initData();
      }
    },
    connects: {
      immediate: true,
      handler() {
        this.initData();
      }
    },
    isEdit: {
      immediate: true,
      handler() {
        this.initData();
      }
    }
  },
  mounted() {
    this.initData();
  },
  onUnmounted() {
    window.removeEventListener('resize', this.handleGraph);
    if (this.graph) {
      this.graph.destroy();
    }
    this.firstRender = false;
    this.tooltip && this.tooltip.$destroy();
  },
  methods: {
    getShowLable() {
      return new Promise(async(resolve, reject) => {
        const nodeOptions = [
          { label: this.$t('pc_menu_type_0'), value: 0 },
          { label: this.$t('pc_menu_type_1'), value: 1 },
          { label: this.$t('pc_menu_type_2'), value: 2, optType: 'openLayer' },
          { label: this.$t('pc_menu_type_3'), value: 3, optType: 'openLayer' }
        ];
        if (this.disableSponsor === false) {
          nodeOptions.push({ label: this.$t('pc_menu_type_4'), value: 4, optType: 'openLayer' });
        }
        try {
          this.roleList = await getAuditRoleByCode(this.tmplCode);
          if (this.roleList.length === 0) {
            this.nodeOptions = nodeOptions.filter(item => item.value !== 2);
          } else {
            this.nodeOptions = nodeOptions;
          }
          resolve();
        } catch (error) {
          this.nodeOptions = nodeOptions;
          reject();
        }
      });
    },
    async createG6() {
      if (!this.graph) {
        if (this.nodeOptions.length === 0) {
          // 判断是否展示审核角色
          await this.getShowLable();
        }
        const container = this.$refs.mountRef;
        const width = container.scrollWidth;
        const height = container.scrollHeight || 500;
        this.tooltip = new AntTooltip({}).$mount(this.$refs.msgRef);
        const graph = await registerAuditCard({
          container,
          width,
          height,
          nodeOptions: this.nodeOptions,
          nodeOptionsMap: this.nodeOptionsMap,
          lang: {
            setup: this.$t('pc_setup'),
            txtEnd: this.$t('pc_end'),
            txtSet: this.$t('pc_set'),
            // eslint-disable-next-line
            txtSetTip: !this.getLang && isIE() ? `${this.$t('pc_set_tip').slice(0,17)}...` : this.$t('pc_set_tip'),
            holderSelectRole: this.$t('pc_select_role'),
            holderSelectFlowRole: this.$t('pc_select_role_flow'),
            txtAudit: this.$t('pc_audit'),
            tipAndSoOn: (n) => this.$t('pc_and_so_on', [n]),
            pcSelectN: (n) => this.$t('pc_select_n', [n]),
            pcRulesNodeMax: (n) => this.$t('pc_rules_node_max', [n]),
            pcTipNoAuditRole: this.$t('pc_tip_no_audit_role')
          },
          tooltip: this.tooltip
        });
        graph.on('event-add-node:click', this.handleAddNode);
        graph.on('event-remove-node:click', this.handleRemoveNode);
        graph.on('event-set-node:click', this.openSetLayer);
        graph.on('clickcheckboxopenlayer', this.openDrawerRoles);
        graph.on('menucheckboxchange', this.handleRollesChange);
        graph.on('viewportchange', this.handleVPChange);
        graph.on('nodeselectchange', this.handleSelectNode);
        window.addEventListener('resize', this.handleGraph);
        this.graph = graph;
      }
    },
    async initData() {
      console.debug({
        isEdit: this.isEdit,
        connects: this.connects,
        nodeList: this.nodeList,
        mountRef: this.$refs.mountRef
      });

      if (!this.$refs.mountRef) return;

      if (typeof this.isEdit !== 'boolean') return;

      if (this.isEdit === true && this.connects && this.nodeList && !(this.connects.length > 0 && this.nodeList.length > 0)) return;

      if (this.loading === true) return;

      try {
        this.loading = true;
        if (!this.graph) {
          await this.createG6();
        }
        await this.getOptionRoles();
        if (this.nodeList && this.connects && this.nodeList.length > 0 && this.connects.length > 0) {
          this.setEditDefault();
          this.renderOrReflash();
        } else {
          this.createNewDefault();
          this.renderOrReflash();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    handleCancelDelete(i, item) {
      item.selected = false;
      this.addNodeByIndex(i, item);
    },
    createNode(val = {}) {
      return {
        label: '',
        value: '',
        id: uuid(),
        type: 'cardAudit',
        selected: false,
        ...val
      };
    },
    getEdgesByNodes(nodes) {
      const edges = [];
      for (let i = 0; i < nodes.length - 1; i++) {
        edges[i] = {
          source: nodes[i].id,
          target: nodes[i + 1].id,
          type: 'edgeAuditAdd'
        };
      }
      return edges;
    },
    createNewDefault() {
      this.nodes = [
        {
          id: 'startEvent',
          type: 'cardAuditStart',
          value: '',
          label: ''
        },
        this.createNode({ auditPersType: 0 }),
        {
          label: this.$t('pc_end'),
          id: 'endEvent',
          type: 'cardAuditEnd',
          size: [67, 36]
        }
      ];
      this.edges = this.getEdgesByNodes(this.nodes);
    },
    setEditDefault() {
      const arr = [];
      let start = null; let end = null;
      try {
        // nodeOptions nodeOptions
        this.nodeList.forEach(it => {
          switch (it.taskRef) {
            case 'startEvent':
              // eslint-disable-next-line
              start = { 
                ...it,
                id: it.taskRef,
                type: 'cardAuditStart',
                label: this.nodeOptionsMap[it.auditPersType]
              };
              if (!it.appters) it.appters = [];
              if (!it.userGroup) it.userGroup = [];
              if (it.appters.length && it.userGroup.length) {
                start.label = this.$t('pc_rules_no_audit_02', [it.appters.length, it.userGroup.length]);
              } else if (it.userGroup.length) {
                start.label = this.$t('pc_rules_no_audit_01', [it.userGroup.length]);
              } else {
                start.label = this.$t('pc_rules_no_audit', [it.appters.length]);
              }
              break;
            case 'endEvent':
              end = {
                ...it,
                id: it.taskRef,
                type: 'cardAuditEnd',
                size: [67, 36],
                label: this.nodeOptionsMap[it.auditPersType]
              };
              break;
            default: {
              const { appters, userGroup, ...others } = it;
              let arry = [];
              let arryGroup = [];
              if (appters) {
                arry = appters.filter(m => m.userId);
              }
              if (userGroup) {
                arryGroup = userGroup.filter(m => m.id);
              }
              arr.push({
                ...others,
                id: it.taskRef,
                type: 'cardAudit',
                label: this.nodeOptionsMap[it.auditPersType],
                appters: arry,
                userGroup: arryGroup
              });
            }
          }
        });
        const arry = [start, ...arr, end];
        this.edges = this.connects.map(it => ({
          ...it,
          source: it.srcRef,
          target: it.trgtRef,
          type: 'edgeAuditAdd'
        }));
        const STMap = this.edges.reduce((cur, it) => {
          cur[it.source] = it.target;
          return cur;
        }, {});
        const nodesMap = arry.reduce((cur, it) => {
          cur[it.id] = it;
          return cur;
        }, {});
        let c = start.id;
        // let c = data.edges.find(it => it.source === fNode.id)
        const nodes = [];
        while (c) {
          nodes.push(nodesMap[c]);
          c = STMap[c];
        }
        this.nodes = nodes;
      } catch (e) {
        // error
        let msg = typeof e === 'string' ? e : '';
        if (!msg) {
          if (e.message) {
            msg = e.message;
          }
          if (e.error && e.error.message) {
            msg = e.error.message;
          }
        }
        this.$message.error(msg);
      }
    },
    renderOrReflash() {
      const nodes = this.nodes.map((it) => ({ ...it }));
      const edges = this.edges.map(it => ({ ...it }));
      console.debug('renderOrReflash', this.firstRender, nodes, edges);

      if (this.firstRender === true) {
        this.graph.changeData({ nodes, edges }, true);
        this.graph.refresh();
      } else {
        this.graph.read({ nodes, edges });
        this.firstRender = true;
      }
    },
    handleSelectNode(evt) {
      const { select, id } = evt;
      const nodes = this.nodes.map((it) => ({ ...it }));
      nodes.forEach(it => {
        if (it.id === id) {
          if (select === true) {
            it.selected = true;
          } else {
            it.selected = false;
          }
        } else if (it.selected === true) {
          it.selected = false;
        }
        it.optionRoles = this.optionRoles;
      });

      this.nodes = nodes;
    },
    async getOptionRoles() {
      try {
        this.loading = true;
        const list = this.roleList;
        this.optionRoles = list;
      } catch (e) {
        console.error(e);
        // error
        let msg = typeof e === 'string' ? e : '';
        if (!msg) {
          if (e.message) {
            msg = e.message;
          }
          if (e.error && e.error.message) {
            msg = e.error.message;
          }
        }
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    },
    handleGraph() {
      const { graph } = this;
      const container = this.$refs.mountRef;
      if (!graph || graph.get('destroyed')) return;
      if (!container || !container.scrollWidth || !container.scrollHeight) { return; }
      graph.changeSize(container.scrollWidth, container.scrollHeight);
    },
    handleAddNode(evt) {
      evt.stopPropagation = true;
      if (this.nodes.length >= 12) {
        // this.$message.error(this.$t('pc_rules_node_max', [10]))
        return;
      }
      const m = evt.item.get('model');
      const pNI = this.nodes.findIndex((it) => it.id === m.source);
      const nNode = this.createNode();
      this.addNodeByIndex(pNI + 1, nNode);
    },
    addNodeByIndex(index, nNode) {
      const nodes = this.nodes.map((it) => ({ ...it }));
      nodes.splice(index, 0, nNode);
      this.nodes = nodes;
      this.edges = this.getEdgesByNodes(this.nodes);
      setTimeout(() => {
        // 动画地移动
        this.graph.focusItem(nNode.id, true);
      });
    },
    handleRemoveNode(evt) {
      evt.stopPropagation();
      const m = evt.item.get('model');
      const pNI = this.nodes.findIndex((it) => it.id === m.id);
      const nodes = this.nodes.map((it) => ({ ...it }));
      const sNode = nodes.splice(pNI, 1)[0];
      this.nodes = nodes;
      this.edges = this.getEdgesByNodes(this.nodes);
      const prev = nodes[pNI - 1];
      const h = this.$createElement;

      if (this._msg) {
        this._msg.close();
      }
      this._msg = this.$message({
        type: 'success',
        message: h('p', null, [
          h('span', null, this.$t('pc_delete_node_tip')),
          h('span', {
            style: 'color: var(--color-primary);margin-left: 10px;cursor: pointer;',
            on: {
              click: () => {
                this._msg.close();
                if (sNode) {
                  this.handleCancelDelete(pNI, { ...sNode });
                }
                this._msg = null;
              }
            }
          }, this.$t('pc_revocation'))
        ])
      });

      setTimeout(() => {
        // 动画地移动
        prev && this.graph.focusItem(prev.id, true);
      });
    },

    handleSetOk(v) {
      // 无需审核：N人
      const { nodeId } = this.startSetLayer;
      let label = '';
      if (v.appters.length && v.userGroup.length) {
        label = this.$t('pc_rules_no_audit_02', [v.appters.length, v.userGroup.length]);
      } else if (v.userGroup.length) {
        label = this.$t('pc_rules_no_audit_01', [v.userGroup.length]);
      } else {
        label = this.$t('pc_rules_no_audit', [v.appters.length]);
      }
      this.changeNodeById(nodeId, {
        label,
        appters: v.appters,
        userGroup: v.userGroup,
        auditType: null
      });
      this.closeNodeSelect();
      this.startSetLayer.visible = false;
    },

    handleAuditRoleOk(v) {
      const { nodeId, value } = this.auditRoleLayer;
      this.auditRoleLayer.visible = false;
      this.changeNodeById(nodeId, {
        auditPersType: value,
        auditRole: v.roleList.map(it => it.id).join(','),
        roleList: v.roleList,
        auditType: v.auditType
      });
      this.closeNodeSelect();
      this.$message.success(this.$t('pc_audit_set_ok'));
    },

    handleOptionalRoleOk(v) {
      this.optionalRoleLayer.visible = false;
      const { nodeId, value } = this.optionalRoleLayer;
      this.changeNodeById(nodeId, {
        auditPersType: value,
        selType: v.selType,
        selRange: v.selRange,
        auditType: v.auditType,
        appters: v.selRange === 0 ? [] : v.appters
      });
      this.closeNodeSelect();
      this.$message.success(this.$t('pc_audit_set_ok'));
    },

    handleAssignRoleOk(v) {
      this.assignRoleLayer.visible = false;
      const { nodeId, value } = this.assignRoleLayer;
      this.changeNodeById(nodeId, {
        auditPersType: value,
        appters: v.appters,
        auditType: v.auditType
      });
      this.closeNodeSelect();
      this.$message.success(this.$t('pc_audit_set_ok'));
    },
    /**
     * val {value, label}
     */
    changeNodeById(id, val) {
      const nodes = this.nodes.map((it) => ({ ...it }));
      const node = nodes.find(it => it.id === id);
      Object.assign(node, { ...val });
      this.nodes = nodes;
    },
    closeNodeSelect() {
      const nodes = this.nodes.map((it) => ({ ...it, selected: false }));
      this.nodes = nodes;
    },
    handleRollesChange(evt) {
      const { nodeId, value } = evt;
      this.changeNodeById(nodeId, {
        auditPersType: value,
        roleList: null,
        appters: null,
        selected: !(value < 2)
      });
    },
    openSetLayer(evt) {
      const { id } = evt.item.getModel();
      const it = this.nodes.find(it => it.id === id);
      let appters = [];
      let userGroup = [];
      if (it.appters) {
        appters = it.appters.filter(it => it.userId);
      } else if (it.auditRole) {
        appters = it.auditRole.split(',').map(userId => ({ userId }));
      }
      if (it.userGroup) {
        userGroup = it.userGroup.filter(it => it.id);
      }
      Object.assign(this.startSetLayer, {
        nodeId: id,
        appters,
        userGroup
      });
      this.startSetLayer.visible = true;
    },
    openDrawerRoles(evt) {
      const { nodeId, value, selected } = evt;
      switch (value) {
        case 2: {
          const obj = {};
          if (selected) {
            const it = this.nodes.find(it => it.id === nodeId);
            obj.auditType = it.auditType;
            obj.roleList = it.roleList.filter(it => it.id);
          }
          // hack appters
          Object.assign(this.auditRoleLayer, {
            value,
            nodeId,
            default: obj
          });
          this.auditRoleLayer.visible = true;
        }
          break;
        case 3: {
          const obj = {};
          if (selected) {
            const it = this.nodes.find(it => it.id === nodeId);
            obj.auditType = it.auditType;
            obj.appters = it.appters.filter(it => it.userId);
          }
          Object.assign(this.assignRoleLayer, {
            value,
            nodeId,
            default: obj
          });
          this.assignRoleLayer.visible = true;
        }
          break;
        case 4:
          {
            const obj = {};
            if (selected) {
              const it = this.nodes.find(it => it.id === nodeId);
              obj.selType = it.selType;
              obj.selRange = it.selRange;
              obj.auditType = it.auditType;
              obj.appters = it.appters.filter(it => it.userId);
            }
            Object.assign(this.optionalRoleLayer, {
              value,
              nodeId,
              default: obj
            });
            this.optionalRoleLayer.visible = true;
          }
          break;
      }
    },
    handleZoomChange(v) {
      const center = this.graph && this.graph.getGraphCenterPoint();
      this.graph && this.graph.zoomTo(parseFloat(v / 100), center);
      this.drawZoom = v;
    },
    handleVPChange(v) {
      const { action, matrix } = v;
      if (action === 'zoom') {
        // eslint-disable-next-line radix
        this.drawZoom = parseInt(matrix[0] * 100);
      }
    },
    async validateForm() {
      const hasNone = this.nodes.some((it) => {
        if (['endEvent', 'startEvent'].includes(it.taskRef || it.id)) {
          return false;
        }
        if (isNaN(it.auditPersType) && typeof it.auditPersType === 'undefined') {
          this.$message.error(this.$t('pc_set_audit_role'));
          return true;
        }
        return false;
      });
      if (hasNone) {
        return false;
      }
      const ret = await new Promise((resolve) => {
        resolve(this.getData());
      });
      return ret;
    },
    getData() {
      return {
        connects: this.edges.map(it => ({
          srcRef: it.source,
          trgtRef: it.target,
          cond: it.cond || ''
        })),
        nodeList: this.nodes.map(it => {
          const obj = {
            auditRole: ''
          };
          if (it.auditPersType === 2) {
            obj.auditRole = it.roleList.map(it => it.id).join(',');
            obj.roleList = it.roleList;
          }

          return {
            auditPersType: it.auditPersType,
            ...obj,
            auditType: it.auditType || 0,
            selRange: it.selRange || 0,
            selType: it.selType || 0,
            taskRef: it.id,
            tmplCode: it.tmplCode || '',
            appters: it.appters,
            userGroup: it.userGroup
          };
        })
      };
    }
  }
};
</script>
<style scoped lang="scss" >
.step {
  flex: 1;
  position: relative;
  .drawing {
    user-select: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.node-card {
  width: 164px;
  height: 80px;
  padding: 1px;
  background: #fff;
  border: 1px solid #e6eeff;
  border: 1px solid hsl(225, 61%, 86%);
  border-radius: 4px;
  transform: translate(4px, 4px);

  &:hover {
    padding: 0;
    border: 2px solid #6b90ff;
    border-radius: 4px;
    box-shadow: 4px 4px 9px 1px rgba(30, 103, 225, 0.08);
  }
}

.btn-delete {
  width: 100%;
  height: 100%;
  padding: 0;

  &:hover {
    background-color: red;
  }
}

.btn-close {
  fill: #d9d9d9;

  &:hover {
    fill: #8c8c8c;
  }
}

.tool-bar-slider {
  position: absolute;
  width: 40px;
  height: 149px;
  left: 36px;
  bottom: 36px;
}
.cancel-delete {
  color: var(--color-primary);
}
</style>
